// extracted by mini-css-extract-plugin
module.exports = {"SpecialtiesSection":"SpecialtiesSection_SpecialtiesSection__1cMHa","Specialties":"SpecialtiesSection_Specialties__m20KE","Categories":"SpecialtiesSection_Categories__2jBSC"};